(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 2227:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(7980);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./components/common/Card/Card.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  margin-bottom: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b67df60f-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, (param)=>{
    let { theme  } = param;
    return theme.boxShadow.blue;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xl;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xl;
});

;// CONCATENATED MODULE: ./components/common/Card/index.tsx



const Card = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        className: className,
        children: children
    });
};
/* harmony default export */ var common_Card = (Card);


/***/ }),

/***/ 7980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ About; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./components/common/Card/index.tsx + 1 modules
var Card = __webpack_require__(2490);
;// CONCATENATED MODULE: ./components/containers/about/OurMission.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 7rem;\n  @media (max-width: ",
        ") {\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 67%;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 5rem 0 4rem;\n  margin: 8rem auto 6rem;\n  color: ",
        ";\n  h3 {\n    margin-bottom: 2rem;\n  }\n  h4 {\n    font-weight: 400;\n  }\n  p {\n    margin-bottom: 0;\n  }\n  @media (max-width: ",
        ") {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1bd0067e-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-1bd0067e-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});

// EXTERNAL MODULE: ./components/common/Container/index.tsx + 1 modules
var Container = __webpack_require__(7987);
;// CONCATENATED MODULE: ./components/containers/about/OurMission.tsx



function OurMission() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: "Our Mission"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Unlock sustainable, long-term, and accessible opportunities for all"
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(7236);
;// CONCATENATED MODULE: ./components/containers/about/Team.styles.ts

function Team_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(5, 200px);\n  justify-content: space-between;\n  @media (max-width: ",
        ") {\n    grid-template-columns: repeat(4, 140px);\n  }\n  @media (max-width: ",
        ") {\n    grid-template-columns: repeat(2, 140px);\n  }\n"
    ]);
    Team_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Team_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 7rem;\n  @media (max-width: ",
        ") {\n    padding: 0;\n  }\n"
    ]);
    Team_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  opacity: 0;\n  z-index: 1;\n  justify-content: center;\n  align-items: center;\n  color: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  backdrop-filter: blur(0.2rem);\n  svg {\n    width: 3.2rem;\n    display: block;\n    margin: 0 1rem;\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  aspect-ratio: 1/1;\n  border-radius: ",
        ";\n  img {\n    filter: grayscale(100%);\n    height: 100%;\n    width: 100%;\n  }\n  :hover {\n    ",
        " {\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2rem 0;\n  h4 {\n    text-transform: capitalize;\n  }\n  span {\n    padding: 1rem 0 4rem;\n    display: block;\n    font-size: 1.4rem;\n    color: ",
        ";\n  }\n  @media (max-width: ",
        ") {\n    padding: 1rem 0;\n    span {\n      padding: 1rem 0 2rem;\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c3c5691-0"
})(Team_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Team_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c3c5691-1"
})(Team_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const Links = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c3c5691-2"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
}, (param)=>{
    let { theme  } = param;
    return "".concat((0,polished_esm/* rgba */.m4)(theme.colors.primary.main, 0.8));
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
});
const PhotoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c3c5691-3"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, Links);
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c3c5691-4"
})(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.darkGray;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/icons/index.js + 56 modules
var icons = __webpack_require__(2667);
// EXTERNAL MODULE: ./components/common/Link/index.tsx + 1 modules
var Link = __webpack_require__(157);
;// CONCATENATED MODULE: ./public/team/oz.png
/* harmony default export */ var oz = ({"src":"/_next/static/media/oz.a16bf19a.png","height":250,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEWVlZU/Pz+IiIidnZ1ISEgwMDBVVVWrq6s4ODh+fn5ubm56enqhoaFzc3NhYWG9vb3Jyclvb2/z9t6GAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVQImQXBhwEAEBAAscNX3f7LShi0sd07o83jzEfitzqPbO556dRch5kLi6hY2ZgU6aaBSNEI1Q9GvAHOn9KmcAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/team/tomer.png
/* harmony default export */ var tomer = ({"src":"/_next/static/media/tomer.77188a54.png","height":250,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEUzMzM7OzsHBwefn58eHh4VFRUrKytwcHBFRUVWVlaPj4+Dg4OysrK/v7/g4OCWABHFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImR3GQRKAIAwEwdklARLU/z/X0j41EySAiUbzt8a1vql6LAlJtTYbZZwTGcjxtNNM571tvx2MAP5QuooUAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/team/rafa.png
/* harmony default export */ var rafa = ({"src":"/_next/static/media/rafa.62cc6498.png","height":250,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEW7u7uysrJRUVGTk5PS0tKLi4ttbW2mpqaOjo7m5uYwMDB9fX1JSUne3t4+Pj5cXFxYWFgbGxuWlpb09PRpI7cuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVQImQXBhwHAIAwDMGcnbOj/v1ZCqt+NqTBqPawKQsufaQE6Tsb8kLE5qQDufgIIDJFhxA7ptyW39QNFBAHi6GuYqgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/team/yotam.png
/* harmony default export */ var yotam = ({"src":"/_next/static/media/yotam.aae97f2e.png","height":250,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEVtbW2enp6rq6sHBwd7e3tKSkqFhYVkZGS6uro5OTnFxcXLy8uvr69cXFyMjIxVVVUrKyvw8PASEhIqKirX0a6NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVQImQXBBwLAIAgAsUNBhlo7/v/XJmgTxaM4nhbSGjU+1hhKjXTlEjb7WPrEHOs9hfQZbye411MXGj86pwHDsd3GwwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/team/jason.png
/* harmony default export */ var jason = ({"src":"/_next/static/media/jason.4c09ca35.png","height":250,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEXAwMBKSkp/f3+YmJheXl63t7enp6ehoaGNjY0pKSlRUVG6urpra2uTk5M1NTUJCQmurq7Kyso5OTkWFhbd3d06Ojp2dnb3Ah/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPklEQVQImQXBhwHAIAwDMIdswuj+/9RK6CJdYk68lKSjNRDl93A4mKXbqQogrkAVymQ1L0XkTvcDuHeuYeY/RW8CB+f7gM8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/team/hannah.png
/* harmony default export */ var hannah = ({"src":"/_next/static/media/hannah.521db2d9.png","height":250,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEUyMjJLS0snJydFRUU6OjqlpaUZGRlBQUFZWVkLCwvMzMxiYmKZmZmRkZHaK35/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAANklEQVQImQXBiQHAMAwCsQMc5+3+61YCCpIJ5XVLAXqcSJT9jRVReBxFgO9CodtPzmT3fm97/h/iAQ9pGvkqAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/team/alvin.png
/* harmony default export */ var alvin = ({"src":"/_next/static/media/alvin.acdc48c9.png","height":200,"width":200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEVTU1M2NjaQkJD+/v4ICAj29vaurq4/Pz/q6urJycnZ2dlxcXEpKSkcHBxeXl6/v7+goKBHR0d7e3vf39/c3NwCmPhGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPklEQVQImRXIRxLAIAwAsTUYF1rq/9+aiY6it8ed/RLVBMsk6nkxShDNuEs2ehziJSoDn/6P6gSXjaqnyVofQswBwWR35uUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/team/ross.png
/* harmony default export */ var ross = ({"src":"/_next/static/media/ross.a921c544.png","height":250,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEW+vr4vLy/S0tK5ubnJycmQkJCGhoazs7NwcHBXV1d6enpHR0cmJiY8PDxjY2Otra2mpqYGBgajHCFMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVQImQXBBwLAIAgAsUNBhrP//2wTUFxba/Sb5qjSRzoO+Jj17u1YzWORQZRIxhRiL7E6h/WtGHvnDzamAdZX/MqiAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/team/nestor.jpg
/* harmony default export */ var nestor = ({"src":"/_next/static/media/nestor.2cfb39dd.jpg","height":250,"width":250,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAABAgUFAAAAAAAAAAAAAAAAAgMBBRESEyEiMVFx/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/xAAVEQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEQMRAD8AlVThlO2xVYPYcl2nHXoAJhr/2Q==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/team/julian.jpg
/* harmony default export */ var julian = ({"src":"/_next/static/media/julian.98daa14c.jpg","height":250,"width":250,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAgEAAABQMFAAAAAAAAAAAAAAAAAQIEBQMRIQYSFXGR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAZEQEAAgMAAAAAAAAAAAAAAAABABECAyH/2gAMAwEAAhEDEQA/AIEjBcjpNLlrEpbuCcHuq0kWIkYLu2fbgAAYcsl9jaT/2Q==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/containers/about/Team.tsx
















function Team() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Team_styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Our Team"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "We are an experienced team in the DeFi space."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Member, {
                            image: oz,
                            first: "oz",
                            last: "rabinovitch",
                            title: "CEO",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://www.linkedin.com/in/oz-rabinovitch/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLinkedin */.jb, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://twitter.com/OzDeFiWizard",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconTwitter */.JD, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Member, {
                            image: tomer,
                            first: "tomer",
                            last: "mayara",
                            title: "CTO",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://www.linkedin.com/in/tomermayara/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLinkedin */.jb, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://twitter.com/tomermayara",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconTwitter */.JD, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Member, {
                            image: rafa,
                            first: "rafa",
                            last: "aguiar",
                            title: "CMO",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://www.linkedin.com/in/rafael-a-silva/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLinkedin */.jb, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://twitter.com/raaguiars",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconTwitter */.JD, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {
                            image: yotam,
                            first: "yotam",
                            last: "daniel",
                            title: "Developer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://www.linkedin.com/in/yotam-daniel-a0951162/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLinkedin */.jb, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Member, {
                            image: jason,
                            first: "jason",
                            last: "stockman",
                            title: "Developer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://www.linkedin.com/in/jasonstockman/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLinkedin */.jb, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://github.com/jasonstockman",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconGitHub */.Mr, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {
                            image: hannah,
                            first: "hannah",
                            last: "leitch",
                            title: "Lead Product Designer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://www.linkedin.com/in/hannah-leitch-07771368/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLinkedin */.jb, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {
                            image: alvin,
                            first: "alvin",
                            last: "thomas",
                            title: "Community Manager",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://www.linkedin.com/in/vinalvinthomas/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLinkedin */.jb, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {
                            image: ross,
                            first: "ross",
                            last: "O'Donovan",
                            title: "Senior Product Manager",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://www.linkedin.com/in/ross-o-3670ab169/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLinkedin */.jb, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {
                            image: nestor,
                            first: "nestor",
                            last: "olivares",
                            title: "Software Engineer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://www.linkedin.com/in/nestorolivaresh/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconLinkedin */.jb, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {
                            image: julian,
                            first: "julian",
                            last: "castrence",
                            title: "Developer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://twitter.com/jrcarchimedesfi",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconTwitter */.JD, {})
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function Member(param) {
    let { children , image , first , last , title  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhotoWrapper, {
                children: [
                    children !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(Links, {
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image,
                        placeholder: "blur",
                        alt: "".concat(first, " ").concat(last)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: first
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: last
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: title
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/containers/about/JoinUs.styles.ts

function JoinUs_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 7rem;\n  text-align: center;\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 64px 0;\n  p {\n    display: block;\n    padding: 2rem 0 3rem;\n  }\n  @media (max-width: ",
        ") {\n    margin-top: 2rem;\n    padding: 32px 0;\n  }\n"
    ]);
    JoinUs_styles_templateObject = function() {
        return data;
    };
    return data;
}

const JoinUs_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c6d023a-0"
})(JoinUs_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.lighter;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});

;// CONCATENATED MODULE: ./components/containers/about/JoinUs.tsx




function JoinUs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(JoinUs_styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                    children: [
                        "We're looking",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "to grow our team"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Want to join us?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "https://careers.archimedesfi.com",
                    target: "_blank",
                    rel: "noreferrer",
                    variant: "button",
                    children: "View Open Positions"
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/common/Footer/SocialMediaLink/SocialMediaLink.tsx + 1 modules
var SocialMediaLink = __webpack_require__(1882);
;// CONCATENATED MODULE: ./components/common/CommunityBar.styles.ts

function CommunityBar_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 7rem 0 17rem;\n  display: flex;\n  color: ",
        ";\n  justify-content: space-between;\n  width: 600px;\n  margin: 0 auto;\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    width: 100%;\n    padding: 4rem 0;\n    margin: 6rem 0;\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    h4 {\n      text-align: center;\n      padding-bottom: 2rem;\n    }\n  }\n"
    ]);
    CommunityBar_styles_templateObject = function() {
        return data;
    };
    return data;
}
function CommunityBar_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    width: 100%;\n  }\n"
    ]);
    CommunityBar_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function CommunityBar_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0px;\n  margin-left: 4rem;\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n  svg {\n    fill: ",
        ";\n  }\n  @media (max-width: ",
        ") {\n    margin: 1rem 0;\n  }\n"
    ]);
    CommunityBar_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const CommunityBar_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5dac7570-0"
})(CommunityBar_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
});
const SocialMediaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5dac7570-1"
})(CommunityBar_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const StyledSocialMediaLink = (0,styled_components_browser_esm/* default */.ZP)(SocialMediaLink/* default */.Z).withConfig({
    componentId: "sc-5dac7570-2"
})(CommunityBar_styles_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});

;// CONCATENATED MODULE: ./components/common/CommunityBar.tsx



function CommunityBar(param) {
    let { mode  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommunityBar_styles_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: "Join our community"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialMediaContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSocialMediaLink, {
                            type: "discord"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSocialMediaLink, {
                            type: "twitter"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSocialMediaLink, {
                            type: "medium"
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/containers/about/Investors.styles.ts

function Investors_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding-top: 80px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    Investors_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Investors_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 64px 0;\n  color: ",
        ";\n"
    ]);
    Investors_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function Investors_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-around;\n  padding: 5rem 0;\n  a {\n    display: block;\n    position: relative;\n    margin: 2rem;\n  }\n  @media (max-width: ",
        ") {\n    img {\n      max-width: 90%;\n    }\n  }\n"
    ]);
    Investors_styles_templateObject2 = function() {
        return data;
    };
    return data;
}

const Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d8dfc3d-0"
})(Investors_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.darkestGray;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
});
const Hero = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-5d8dfc3d-1"
})(Investors_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});
const Investors_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d8dfc3d-2"
})(Investors_styles_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});

;// CONCATENATED MODULE: ./components/containers/about/Investors.tsx




function Investors() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Background, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Investors & Partners"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Investors_styles_Wrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "https://shima.capital/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/partners/shima.svg",
                                alt: "Shima Captial",
                                height: 38
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "https://hack.vc/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/partners/hackvc.svg",
                                alt: "HackVC",
                                height: 34
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "https://bitscale.vc",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/partners/bitscale.svg",
                                alt: "Bitscale Captial",
                                height: 47
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "https://www.originprotocol.com/en/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/partners/origin.svg",
                                alt: "Origin",
                                height: 30
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "https://halborn.com/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/partners/halborn.svg",
                                alt: "Halborn",
                                height: 35
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "https://palsar.vc/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/partners/palsar.svg",
                                alt: "Palsar",
                                height: 23
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/containers/about/About.styles.ts

function About_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n  display: flex;\n  h2 {\n    margin-bottom: 2.4rem;\n  }\n"
    ]);
    About_styles_templateObject = function() {
        return data;
    };
    return data;
}
function About_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 64px 0 128px;\n  position: relative;\n  img {\n    position: absolute;\n    right: 0;\n    bottom: 60px;\n    width: 450px;\n    max-width: 50%;\n  }\n\n  @media (max-width: ",
        ") {\n    padding: 48px 0 43px 0;\n    img {\n      position: relative;\n      bottom: 0;\n      max-width: 100%;\n    }\n  }\n"
    ]);
    About_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function About_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 390px;\n  max-width: 95%;\n"
    ]);
    About_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function About_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 67%;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 5rem 0 4rem;\n  margin: 8rem auto 6rem;\n  color: ",
        ";\n  h3 {\n    margin-bottom: 2rem;\n  }\n  h4 {\n    font-weight: 400;\n  }\n  p {\n    margin-bottom: 0;\n  }\n"
    ]);
    About_styles_templateObject3 = function() {
        return data;
    };
    return data;
}


const About_styles_Hero = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2ff5c7d6-0"
})(About_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
});
const HeroWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ff5c7d6-1"
})(About_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const HeroText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ff5c7d6-2"
})(About_styles_templateObject2());
const About_styles_StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-2ff5c7d6-3"
})(About_styles_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
});

;// CONCATENATED MODULE: ./pages/about.page.tsx









function About() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "About ArchimedesFi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "About ArchimedesFi. Our team and values."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About_styles_Hero, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroText, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Our Story"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Archimedes Finance was born from a moment of Eureka."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "As early DeFi adopters, we had growing concerns that the ecosystem is not sustainable; the lending/borrowing markets offer decreasing yields from bonus tokens and poor UX."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "We are Archimedes, the father of leverage: we optimize capital efficiency, generating yield from real economic activity. Our mathematical g(r)eekness and simple UI achieves high long lasting opportunities for all while mitigating some of the risks in the space."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Eureka!"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/about-hero.svg",
                                alt: "Archimedes"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurMission, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Team, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinUs, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityBar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Investors, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,236,774,888,179], function() { return __webpack_exec__(2227); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);